import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=3c8e5918&scoped=true&"
import script from "./LocaleSelector.vue?vue&type=script&lang=js&"
export * from "./LocaleSelector.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSelector.vue?vue&type=style&index=0&id=3c8e5918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e5918",
  null
  
)

export default component.exports